"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiKVDelete = exports.apiKVSet = exports.apiKVGet = void 0;
const client_1 = require("./client");
const util_1 = require("./util");
const apiKVGet = async (after) => {
    const url = (0, util_1.isStudentUser)() ? '/courses/student/kv-get-all' : '/teachers/kv-get-all';
    const { data } = await client_1.default.get(url, {
        params: Object.assign({}, (after && { after: after.getTime() })),
    });
    return data;
};
exports.apiKVGet = apiKVGet;
const apiKVSet = async (key, value) => {
    const url = (0, util_1.isStudentUser)() ? '/courses/student/kv-set' : '/teachers/kv-set';
    await client_1.default.post(url, { key, value });
};
exports.apiKVSet = apiKVSet;
const apiKVDelete = async (key) => {
    const url = (0, util_1.isStudentUser)() ? '/courses/student/kv-delete' : '/teachers/kv-delete';
    await client_1.default.delete(url, { params: { key } });
};
exports.apiKVDelete = apiKVDelete;
//# sourceMappingURL=kvStore.js.map